var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconeye = function SvgIconeye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Icon=eye_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.202 15.462a1.5 1.5 0 0 0 0 1.076C3.038 23.913 9.047 29 16.002 29s12.964-5.087 15.8-12.462a1.5 1.5 0 0 0 0-1.076C28.966 8.087 22.957 3 16.002 3S3.038 8.087.202 15.462m21.8.038a6 6 0 1 1-10.993-3.329 2 2 0 1 0 2.466-2.115 6 6 0 0 1 8.527 5.444",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Icon=eye_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M.002 0h32v32h-32z"
  })))));
};
export default SvgIconeye;